import React from 'react'
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Hero from "components/hero/TwoColumnWithVideo.js";
import tw from "twin.macro";
import "../style.css"
import { css } from "styled-components/macro"; //eslint-disable-line
 let uni = 'https://uskudar.edu.tr/assets/kurumsal/logo/jpg/uskudar-universitesi-logo.jpg'
function USKUDAR() {
    const Subheading = tw.span`tracking-wider text-sm font-medium`;
    const HighlightedText = tw.span`bg-primary-500 text-gray-100 px-4 transform -skew-x-12 inline-block`;
    const HighlightedTextInverse = tw.span`bg-gray-100 text-primary-500 px-4 transform -skew-x-12 inline-block`;
    const Description = tw.span`inline-block mt-8`;
    const imageCss = tw`rounded-4xl`;
    const Container = tw.div`relative`;
    const TwoColumn = tw.div`flex flex-col lg:flex-row md:items-center max-w-screen-xl mx-auto py-20 md:py-24`;
    const Heading = tw.h1`font-black text-black text-3xl md:text-5xl  max-w-3xl`;


  return (
    <AnimationRevealPage>
         <Hero
        heading={<><HighlightedText>Üsküdar University</HighlightedText></>}
        description="Established in 2011, Üsküdar University focuses primarily on health sciences and psychology. It is known for its work in neuroscience, neuropsychiatry, and applied psychology, offering strong research opportunities in these fields."
        imageSrc={uni}
        imageCss={imageCss}
        imageDecoratorBlob={true}
    
      />
            <Container>
      <TwoColumn>
<Heading>Students</Heading>
</TwoColumn>
</Container>
      <Container>
      <TwoColumn>
    



     
      <div className="table-container">
    <table>
        <thead>
            <tr>
                <th>Name</th>
                <th>Department</th>
                <th>University Entrance Year</th>
                <th>FIRST Team Number - Name</th>
                <th>FIRST Programs Participated</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Şevval Yünten </td>
                <td> Grafik Tasarım </td>
                <td> 2021</td>
                <td>  6415</td>
                <td>FRC, FLL</td>
            </tr>
      
        
        </tbody>
    </table>
</div>

</TwoColumn>
</Container>
<Footer />
        </ AnimationRevealPage>
  )
}

export default USKUDAR